import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux'
import { required, email } from 'redux-form-validators'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd';
import {toastr} from 'react-redux-toastr'
import moment from 'moment';
import { CirclePicker } from 'react-color';
import InputField from '../../../../../helpers/Fields/InputField';
import { createFolder, updateFolder } from '../../../../actions';
import SelectField from '../../../../../helpers/Fields/SelectField';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
  }
  

  submit = async (values)=> {
    try {
      const {formatMessage} = this.context;
      const {handleClose} = this.props;
     
      if(values.id){
        await this.props.updateFolder(values);
        toastr.success(formatMessage('msgNotificationTitleFolderCreaded'), formatMessage('msgNotificationFolderCreated'))

      } else {
        await this.props.createFolder(values);
        toastr.success(formatMessage('msgNotificationTitleFolderUpdated'), formatMessage('msgNotificationFolderUpdated'))
      }
      
      handleClose();
    } catch (error) {
    }
    
  }

  render() {
    const {formatMessage} = this.context
    let { handleSubmit, handleClose, initialValues, folders, valuesForm } = this.props;
    if(!valuesForm){
      valuesForm = {};
    }

    let is_change_folder = initialValues.id ? !folders.some(f => {
      if(f.parent_id == initialValues.id){
        return true
      }
    }) : true;

    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='title'
          label={formatMessage('txtCaptionFolderName')}
          component={InputField}
          validate={[required()]}
        />
        {is_change_folder && <Field 
          name='parent_id'
          label={formatMessage('txtCaptionFolderNameParent')}
          component={SelectField}
          labelOption={formatMessage('txtCaptionFolderNotParent')}
          options={folders.filter(item => !item.parent_id && item.id != initialValues.id).map(item => ({title: item.title, value: item.id}))}
        />}
       
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancelFolder')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateFolder': 'btnModalUpdateFolder')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_task',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_task')(state),
  folders: state.folders.list,
})

const mapDispatchToProps = {
  createFolder,
  updateFolder,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/components/Folders/components/FormModal/FormContent.jsx